import React from 'react';
import { PauseFill, PlayFill, SkipEndFill, SkipStartFill } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import { REPLAY_SPEEDS } from '../engine/replay';
import { MOBILE_UI } from '../../constants/mobileUi';

export default function BacktestReplayBar({
  playhead = 0,
  barCount = 0,
  playing = false,
  speed = 2,
  onPlayhead,
  onTogglePlay,
  onStep,
  onSpeed,
  isMobile = false,
  stamp = '',
}) {
  const { colors } = useTheme();
  const hit = isMobile ? MOBILE_UI.touchMin : 32;
  const max = Math.max(0, barCount - 1);
  const btn = {
    width: hit,
    height: hit,
    border: 'none',
    borderRadius: 8,
    background: 'transparent',
    color: colors.text,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    flexShrink: 0,
  };

  return (
    <div
      data-testid="backtest-replay"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: isMobile ? '4px 0' : '6px 0 2px',
        minHeight: hit,
      }}
    >
      <button type="button" style={btn} aria-label="Step back" onClick={() => onStep?.(-1)}>
        <SkipStartFill size={14} />
      </button>
      <button type="button" style={btn} aria-label={playing ? 'Pause' : 'Play'} onClick={onTogglePlay}>
        {playing ? <PauseFill size={16} /> : <PlayFill size={16} />}
      </button>
      <button type="button" style={btn} aria-label="Step forward" onClick={() => onStep?.(1)}>
        <SkipEndFill size={14} />
      </button>
      <input
        type="range"
        min={0}
        max={max}
        value={Math.min(playhead, max)}
        aria-label="Replay position"
        onChange={(e) => onPlayhead?.(Number(e.target.value))}
        style={{ flex: 1, minWidth: 0, accentColor: colors.primary, cursor: 'pointer' }}
      />
      <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
        {REPLAY_SPEEDS.map((s) => (
          <button
            key={s}
            type="button"
            onClick={() => onSpeed?.(s)}
            style={{
              height: 24,
              padding: '0 7px',
              borderRadius: 6,
              border: `1px solid ${speed === s ? colors.primary : colors.border}`,
              background: speed === s ? `${colors.primary}22` : 'transparent',
              color: speed === s ? colors.primary : colors.textMuted,
              fontSize: 11,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {s}×
          </button>
        ))}
      </div>
      {stamp ? (
        <span style={{ fontSize: 11, color: colors.textMuted, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', minWidth: 72, textAlign: 'right' }}>
          {stamp}
        </span>
      ) : null}
    </div>
  );
}
